import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { ReportsService } from '../../services/reports.service';
import { AttendanceComponent } from './attendance/attendance.component';
import { Constants } from '../../../../app.const';
import { TranslateService } from 'ng2-translate';
declare var $: any;

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
})
export class TimesheetComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  date: string;
  attendance_sheets: any = {
    user_name: [],
    user_times: []
  };

  //kauhsalya 2017-09-06 add leave details to attendance chart
  leave_sheets: any = {
    user_name: [],
    user_times: []
  };

  time_sheets: any = {
    user_name: [],
    user_times: []
  };
  private constants = Constants;
  constructor(
    private datePipe: DatePipe,
    private reportsService: ReportsService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {

    let $this = this;
    let date = new Date();
    this.getTimeSheetAndAttendanceByDate(this.datePipe.transform(date, this.constants.dateFormat));

    $('.allocationDate').val(this.datePipe.transform(date, this.constants.dateFormat));
    $('.allocationDate').datepicker({
      autoclose: true,
      minViewMode: 0,
      format: this.constants.dateFormatDatepicker,
      endDate: new Date()
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      $this.date = $this.datePipe.transform(selectDate, $this.constants.dateFormat);
      // get time sheet on chagne
      $this.getTimeSheetAndAttendanceByDate($this.date);
    });
  }

  /**
   * Timesheet time chart
   */
  public timesheetChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public timesheetChartLabels: string[] = [];
  public timesheetChartType: string = 'bar';
  public timesheetChartLegend: boolean = true;

  public timesheetChartData: any[] = [
    { data: [], label: 'Timesheet' },
  ];

  public timesheetChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(26,179,142,1)',
    }
  ];
  // Timesheet chart 

  /**
   * Get timesheet and Attendance by given date for graph  
   * 
   * @param {any} date 
   * 
   * @memberOf TimesheetComponent
   */
  getTimeSheetAndAttendanceByDate(date) {
    this.reportsService.getTimeSheetAndAttendanceByDate({ date }).subscribe(
      res => {
        this.time_sheets = res.data.time_sheets;
        this.attendance_sheets = res.data.attendance_sheets;
        this.leave_sheets = res.data.leave_sheets;

        this.timesheetChartData = [];
        this.timesheetChartData = [
          { data: this.time_sheets.user_times, label: this.translateService.instant('WORKINGhOURS') },
        ];
        this.timesheetChartLegend = true;
        this.timesheetChartLabels = [];
        this.timesheetChartLabels = this.time_sheets.user_name;

        if (this.chart && this.chart.chart && this.chart.chart.config) {
          this.chart.chart.config.data.labels = this.time_sheets.user_name;
          this.chart.chart.update();
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/reports/components/timesheet/timesheet.component.ts